import { useCallback, useState } from 'react'
import QuestionsBuilderModel from '@v4/store/builderStore/models/QuestionsBuilder.model'
import QuestionsBuilderSelector from '@v4/utils/selectors/QuestionsBuilderSelector'
import AppStore from '@v4/store/appStore'
import useWordings from '@v4/hooks/useWordings'
import PageBuilderSelector from '@v4/utils/selectors/PageBuilderSelector'
import PageBuilderModel from '@v4/store/builderStore/models/PageBuilder.model'
import useStyles from './OptionOtherItem.styled'

export const useOptionOtherItem = ({
	optionId,
	onClick,
	gridWidth,
	disabled,
	loading,
	multiple,
	checked,
	onChange,
	value,
}) => {
	const { getWording } = useWordings()
	const { setScrollingMenu, setActiveOptionId, setQuestionTab } = QuestionsBuilderSelector.useActions()
	const isBuilderMode = AppStore.useStoreState(state => state.general.isBuilderMode)
	const isQuestionBuilderMode = PageBuilderSelector.useIsQuestionsMode()
	const { setSidebarMode } = PageBuilderSelector.useActions()

	const [placeholder, setPlaceholder] = useState(false)

	const classes = useStyles({ active: multiple || !!value, multiple, isBuilderMode })

	const handleChange = useCallback(
		({ target }) => {
			onChange(target.value)
		},
		[onChange],
	)

	const handleBlur = useCallback(() => {
		setPlaceholder(false)
	}, [])

	const handleFocus = useCallback(() => {
		setPlaceholder(true)
		if (!isBuilderMode && !isQuestionBuilderMode) return

		setScrollingMenu?.(true)
		setActiveOptionId(optionId)
		setSidebarMode(PageBuilderModel.SIDEBAR_MODE.QUESTIONS)
		setQuestionTab(QuestionsBuilderModel.QUESTION_TAB.LOGIC)
	}, [
		isBuilderMode,
		isQuestionBuilderMode,
		setScrollingMenu,
		setActiveOptionId,
		optionId,
		setSidebarMode,
		setQuestionTab,
	])

	const handlerClick = useCallback(() => {
		onClick({ optionId })
	}, [optionId, onClick])

	const handleKeyUp = useCallback(
		({ key }) => {
			if (key === 'Enter' && !multiple && !isBuilderMode) {
				onClick({ optionId, answer: value })
			}
		},
		[isBuilderMode, multiple, onClick, optionId, value],
	)

	return [
		{
			value,
			gridWidth,
			classes,
			disabled,
			loading,
			checked,
			placeholder: getWording(placeholder ? 'pleaseSpecify' : 'other'),
			readOnly: isBuilderMode,
		},
		{ handleChange, handlerClick, handleFocus, handleKeyUp, handleBlur },
	]
}
